import { Pipe, PipeTransform } from '@angular/core';

export type blocksDaysTypes = 'blockSchedule' | 'holiday' ;
export type blocksDaysTypesTranslated = 'Não Trabalhado' | 'Feriado' ;

@Pipe({
  name: 'translateBlockDayType'
})
export class TranslateBlockDaysPipe implements PipeTransform {

  private blockDaysMap: Record<blocksDaysTypes, blocksDaysTypesTranslated> = {
    blockSchedule: 'Não Trabalhado',
    holiday: "Feriado"
  };

  transform(value: blocksDaysTypes): blocksDaysTypesTranslated {
    return this.blockDaysMap[value] || 'Outro'; 
  }
}
